/* BIA luxe layer.
   1. THE EDIT rail progress. Native scroll does the moving; JS only reports.
   2. Add to Bag micro-interaction, with a real form fallback if fetch fails.
   3. Scroll reveals with a fail-safe so content can never stay invisible.
   All progressive: with JS off, links and the form still work. */
(function () {
  var B = 'biaLuxeBound';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- THE EDIT rail ---------- */
  function initRail(root) {
    if (root[B]) return; root[B] = true;
    var sec = root.closest('.led');
    var cards = root.querySelectorAll('.led__c');
    if (!cards.length || !sec) return;
    var pos = sec.querySelector('[data-bia-rail-pos]');
    var bar = sec.querySelector('[data-bia-rail-bar]');
    var raf = null;
    function sync() {
      var c = root.scrollLeft + root.clientWidth / 2, best = 0, bd = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var m = cards[i].offsetLeft + cards[i].offsetWidth / 2;
        var d = Math.abs(m - c);
        if (d < bd) { bd = d; best = i; }
      }
      if (pos) pos.textContent = pad(best + 1) + ' / ' + cards.length;
      if (bar) bar.style.width = Math.round(((best + 1) / cards.length) * 100) + '%';
    }
    root.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });
    root.addEventListener('keydown', function (e) {
      var w = cards[0] ? cards[0].offsetWidth + 14 : 320;
      if (e.key === 'ArrowRight') { e.preventDefault(); root.scrollBy({ left: w, behavior: reduce ? 'auto' : 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); root.scrollBy({ left: -w, behavior: reduce ? 'auto' : 'smooth' }); }
    });
    sync();
  }

  /* ---------- Add to Bag ---------- */
  function initBuy(form) {
    if (form[B]) return; form[B] = true;
    var btn = form.querySelector('[data-bp-buy]');
    if (!btn) return;
    var label = btn.textContent.trim();
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;               /* let the browser post normally */
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return;
      btn.setAttribute('data-state', 'adding');
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id.value), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        btn.setAttribute('data-state', 'added');
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('bia:cart:added'));
        var opener = document.querySelector('[data-cart-drawer-open], a[href="/cart"], .header__cart');
        if (opener && opener.click) { try { opener.click(); } catch (err) {} }
        setTimeout(function () {
          btn.removeAttribute('data-state');
          btn.textContent = label;
        }, 2200);
      }).catch(function () {
        btn.removeAttribute('data-state');
        btn.textContent = label;
        form.submit();                          /* honest fallback */
      });
    });
  }

  /* ---------- reveals ---------- */
  function initReveals() {
    var els = document.querySelectorAll('[data-bia-reveal]');
    if (!els.length) return;
    function showAll() { for (var i = 0; i < els.length; i++) els[i].classList.add('is-in'); }
    if (reduce || !('IntersectionObserver' in window)) { showAll(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        var el = e.target;
        setTimeout(function () { el.classList.add('is-in'); }, Math.min(i, 6) * 60);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
    setTimeout(showAll, 2500);   /* fail-safe */
  }

  function boot(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-bia-rail]'), initRail);
    Array.prototype.forEach.call(s.querySelectorAll('form[action*="/cart/add"]'), initBuy);
    initReveals();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
